import { createApp } from 'vue'
import { createI18n } from '@shared/i18n'
import locales from '../i18n/locales.json'

import Properties from '@pages/agency/Properties.vue'

const i18n = createI18n(locales)

document.addEventListener('DOMContentLoaded', () => {
  createApp(Properties).use(i18n).mount('#agent-properties')
})
